export default "__VITE_ASSET__CtoCe0iG__"